import { dapiFetchCache, xhrFetchCache } from "@origin-digital/daxi";
import { logger } from "@origin-digital/reporting-client";
import { ITrendingItem } from "../components/Trending/TrendingItem";
import { formatQueryParameters } from "../helpers/url.helper";
/* eslint-disable-next-line import/extensions */
import content from "../cms/faq.json";
import { CustomerContext } from "../../../shared/interface/navigation";
import { path as faqPath } from "../../../shared/interface/faq";

import { IRequestCachingOptions } from "./types";

const bold360FaqPath = "/api/kb/v1/faq";

export interface IFaqParams {
  host: string;
  account: string;
  kb: string;
  labelId: string;
  days?: number;
  items?: number;
  context?: string;
  visitorToken?: string;
  allContextsMandatory?: "true" | "false";
}
export interface IArticleData {
  label: string;
  objectId: string;
}

interface IFaqResponseData {
  data: IArticleData[];
}
export interface IFaqResponse {
  data: IFaqResponseData[];
}

interface ITrendingResponse {
  faq: ITrendingItem[];
}

interface ITrendingParams {
  labelId?: string;
  context?: CustomerContext;
  items?: number;
}

const MAX_TRENDING_ITEMS = 6;

export const mapResponseToData = (
  response: IFaqResponse | undefined
): IArticleData[] | undefined => {
  const data = response ? response.data : undefined;
  if (data && Array.isArray(data) && data.length > 0) {
    return data[0].data;
  }
  return undefined;
};

export const fetchFAQ = async (
  params: IFaqParams,
  options?: IRequestCachingOptions
): Promise<IArticleData[] | undefined> => {
  try {
    const {
      days = content.days,
      items = content.items,
      allContextsMandatory = "false",
    } = params;

    const { ttl = 30 } = options || {};

    const queryParams = formatQueryParameters<IFaqParams>({
      ...params,
      days,
      items,
      allContextsMandatory,
      host: undefined as never,
    });

    const url = `${encodeURI(
      `${params.host}${bold360FaqPath}`
    )}?${queryParams}`;
    logger.info(`[Request] Fetching FAQ at url: ${url}`);
    const { data } = await xhrFetchCache<IFaqResponse>(url, {
      ttlInMin: ttl,
      includeCommonHeaders: false,
    });
    return mapResponseToData(data);
  } catch (error) {
    logger.error("[Request] Error fetching faq results", error);
    return undefined;
  }
};

export const fetchTrendingQuestions = async (
  params?: ITrendingParams,
  options?: IRequestCachingOptions
): Promise<ITrendingItem[] | undefined> => {
  try {
    const { items = MAX_TRENDING_ITEMS } = params || {};
    const { ttl = 30 } = options || {};
    const queryParams = formatQueryParameters<ITrendingParams>({
      ...params,
      items,
    });
    const url = `${encodeURI(faqPath)}?${queryParams}`;
    logger.info(`[Request] Fetching trending questions at url: ${url}`);
    const { data } = await dapiFetchCache<ITrendingResponse>(url, {
      ttlInMin: ttl,
    });
    if (data) {
      return data.faq;
    }
    return undefined;
  } catch (error) {
    logger.error("[Request] Error fetching faq results", error);
    return undefined;
  }
};
